// These prototypes never mount the account, booking, or messaging runtime.
export const isStandaloneLabEntry = ({ environment, hostname, pathname } = {}) =>
  environment === "development" &&
  ["localhost", "127.0.0.1", "[::1]"].includes(hostname) &&
  /^\/lab\/(?:puzzles(?:\/.*)?|helper-communication\/?|helper-home-preview\/?|visit-acceptance\/?|visit-communication\/?)$/u.test(pathname || "");
